// Generated by ts-to-zod
import { z } from 'zod';

export const workflowRunResetPayloadSchema = z.object({
  noteContent: z.string().optional(),
});
